/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-05-17",
    versionChannel: "nightly",
    buildDate: "2025-05-17T00:06:58.639Z",
    commitHash: "e3fdfe18ddc7be516b9a9ce66d1d8cd3e3e3be3f",
};
